import { render, staticRenderFns } from "./FscTable.vue?vue&type=template&id=37176ff0"
import script from "./FscTable.vue?vue&type=script&lang=ts"
export * from "./FscTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports